<template>
  <div
    class="modal fade"
    id="appo_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="login_modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="reg_form_box property_appo" id="datepick">
            <div class="reg_form_box_title">
              <h1>For MLS submission, our dedicated Sales Associate will contact you to discuss further. Please submit your information, we will contact you within 24 hours to schedule an appointment.</h1>
            </div>
            <form>
              <div class="form-row" v-if="formSubmitted">
                <div class="col-md-12 mb-4">
                  <div class="alert" :class="responseClass" role="alert">{{ responseMessage }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12 mb-4">
                  <div class="input_star">
                    <input
                      type="text"
                      class="form-control"
                      :class="nameError ? 'is-invalid' : ''"
                      placeholder="Your Name"
                      v-model="name"
                    />
                  </div>
                  <small class="text-danger d-block" role="alert" v-if="nameError">
                    <strong>{{ nameErrorMessage }}</strong>
                  </small>
                </div>
                <div class="col-md-12 mb-4">
                  <div class="input_star">
                    <input
                      type="text"
                      class="form-control"
                      :class="phoneError ? 'is-invalid' : ''"
                      placeholder="Phone Number (10 digits only)"
                      v-mask="'###-###-####'"
                      v-model="phone"
                    />
                  </div>
                  <small class="text-danger d-block" role="alert" v-if="phoneError">
                    <strong>{{ phoneErrorMessage }}</strong>
                  </small>
                </div>
                <div class="col-md-12 mb-4">
                  <div class="input_star">
                    <input
                      type="email"
                      class="form-control"
                      :class="emailError ? 'is-invalid' : ''"
                      placeholder="Email"
                      v-model="email"
                    />
                  </div>
                  <small class="text-danger d-block" role="alert" v-if="emailError">
                    <strong>{{ emailErrorMessage }}</strong>
                  </small>
                </div>
                <div class="col-md-12 mb-4">
                  <div class="input_star">
                    <textarea
                      class="form-control"
                      :class="addressError ? 'is-invalid' : ''"
                      placeholder="Property Address"
                      v-model="address"
                    ></textarea>
                  </div>
                  <small class="text-danger d-block" role="alert" v-if="addressError">
                    <strong>{{ addressErrorMessage }}</strong>
                  </small>
                </div>
                <div class="col-md-12 mb-4">
                  <div class="input_star">
                    <input
                      type="text"
                      class="form-control"
                      :class="cityError ? 'is-invalid' : ''"
                      placeholder="City"
                      v-model="city"
                    />
                  </div>
                  <small class="text-danger d-block" role="alert" v-if="cityError">
                    <strong>{{ cityErrorMessage }}</strong>
                  </small>
                </div>
                <div class="col-md-12">
                  <div class="form_submit_button">
                    <button
                      type="button"
                      @click.prevent="saveMLSLead"
                      :disabled="processing"
                      :style="processing ? 'opacity:0.6;cursor:not-allowed;' : ''"
                    >{{ processing ? "Processing..." : "Submit MLS Info" }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "MLSLeadsModal",
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      processing: false,
      responseClass: "alert-light",
      responseMessage: "",
      formSubmitted: false
    };
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      minLength: minLength(12)
    },
    address: {
      required
    },
    city: {
      required
    }
  },
  computed: {
    nameError() {
      if (this.$v.name.$error) {
        return true;
      } else {
        return false;
      }
    },
    nameErrorMessage() {
      if (this.$v.name.$error) {
        return "Name is required";
      } else {
        return "";
      }
    },
    phoneError() {
      if (this.$v.phone.$error) {
        return true;
      } else {
        return false;
      }
    },
    phoneErrorMessage() {
      if (this.$v.phone.$error) {
        if (!this.$v.phone.required) {
          return "Phone number is required";
        } else if (!this.$v.phone.minLength) {
          return "Phone number should be 10 digits";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    emailError() {
      if (this.$v.email.$error) {
        return true;
      } else {
        return false;
      }
    },
    emailErrorMessage() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "Email is required";
        } else if (!this.$v.email.email) {
          return "Please enter a valid email address";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    addressError() {
      if (this.$v.address.$error) {
        return true;
      } else {
        return false;
      }
    },
    addressErrorMessage() {
      if (this.$v.address.$error) {
        if (!this.$v.address.required) {
          return "Address is required";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    cityError() {
      if (this.$v.city.$error) {
        return true;
      } else {
        return false;
      }
    },
    cityErrorMessage() {
      if (this.$v.city.$error) {
        if (!this.$v.city.required) {
          return "City is required";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    saveMLSLead() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.processing = true;
        const formData = new FormData();

        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("property_address", this.address);
        formData.append("city", this.city);

        axios
          .post("/api/submit-mls-lead", formData)
          .then(response => {
            let msg = "Successfully submitted MLS data!";
            if (response?.data?.message) {
              msg = response.data.message;
            }
            this.responseMessage = msg;
            this.responseClass = "alert-success";
            this.$v.$reset();
            this.name = "";
            this.email = "";
            this.phone = "";
            this.address = "";
            this.city = "";
          })
          .catch(error => {
            let msg = "Unable to schedule appointment!";
            this.responseClass = "alert-danger";
            if (error?.response?.data?.message) {
              msg = error.response.data.message;
            }
            this.responseMessage = msg;
          })
          .finally(res => {
            this.formSubmitted = true;
            this.processing = false;
            setTimeout(() => {
              this.formSubmitted = false;
              this.responseClass = "alert-light";
              this.responseMessage = "";
            }, 5000);
          });
      }
    }
  }
};
</script>
